/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { FC, useState, useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Facebook from 'assets/svg/facebookwhite.svg';
// import Instagram from 'assets/svg/instagram.svg';
import Pinterest from 'assets/svg/pinterest.svg';
import Twitter from 'assets/svg/twitter.svg';
import MailIcon from 'assets/svg/MailIconwhite.svg';
import {
  PinterestShareButton,
  TwitterShareButton,
  FacebookShareButton,
} from 'react-share';

interface socialShareprops {
  title: string;
  image: any;
  showProductImage?: boolean;
}

// Need to use blog placeholder image instead of this
export const query = () => {
  return useStaticQuery(graphql`
    query backupQuery {
      site {
        siteMetadata {
          image
        }
      }
    }
  `);
};

export const SocialShare: FC<socialShareprops> = ({
  title,
  image,
  showProductImage = false,
}) => {
  const backup = query();
  const [url, setUrl] = useState('');
  const [location, setlocation] = useState('');
  useEffect(() => {
    setUrl(window.location.href);
    setlocation(window.location.origin);
  }, []);
  const imageUrl = `${location}${
    !image ? backup.site.siteMetadata.image : image
  }`;
  return (
    <div className="social_shares_wrapper">
      <span>Share:</span>
      <ul className="social_share">
        <li>
          <FacebookShareButton url={url} quote={title}>
            <Facebook />
          </FacebookShareButton>
        </li>
        <li>
          <TwitterShareButton url={url} title={title}>
            <Twitter />
          </TwitterShareButton>
        </li>
        <li>
          {showProductImage ? (
            <PinterestShareButton url={url} media={image} description={title}>
              <Pinterest />
            </PinterestShareButton>
          ) : (
            <PinterestShareButton
              url={url}
              media={imageUrl}
              description={title}
            >
              <Pinterest />
            </PinterestShareButton>
          )}
        </li>
        <li>
          <a href={`mailto:?subject=${title}&body=${url}`}>
            <MailIcon />
          </a>
        </li>
      </ul>
    </div>
  );
};
